import {useState, useEffect} from 'react';
import {addLabelToArray} from '../helpers';
import {useApi} from '../context';

export default function useCountries() {
    let api = useApi();

    const [isLoading, setIsLoading] = useState(true);
    const [countries, setCountries] = useState([]);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        
        const fetchData = async() => {
            setIsLoading(true)
            let results = null;

                results = await api.getCountries();
          
            if(results.statusCode === 200) {
                let {data, message} = results;

                    let labelledData = (addLabelToArray(data));
                    setCountries(labelledData)
              
            } 
            else {
                let {error} = results;
                setHasError(error);
            }
            // setIsLoading(false);
        }

        fetchData();
        return () => { 
            return [countries, isLoading, hasError ]
        }
    }, [])

    return {countries, isLoading, hasError}
}

export function useCountryStates({refreshVariable, countryId}) {
    let api = useApi();

    const [isLoading, setIsLoading] = useState(true);
    const [countryStates, setCountryStates] = useState([]);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        
        const fetchData = async() => {
            setIsLoading(true)
            let results = null;

                results = await api.getStates(countryId);
          
            if(results.statusCode === 200) {
                let {data, message} = results;

                    let labelledData = (addLabelToArray(data));
                    setCountryStates(labelledData)
              
            } 
            else {
                let {error} = results;
                setHasError(error);
            }
            // setIsLoading(false);
        }

        fetchData();
        return () => { 
            return [countryStates, isLoading, hasError ]
        }
    }, [refreshVariable])

    return {countryStates, isLoading, hasError}
}